export { FormRender } from './FormRender'
export type { FormRenderProps, CurrentSchema, JsonSchemaResult } from './types'

export const defaultStylesForButtons = {
  submit: {
    variant: 'filled',
    backgroundColor: '#0BD68D',
    color: '#FFFFFF',
  },
  next: {
    variant: 'filled',
    backgroundColor: '#014ee6',
    color: '#FFFFFF',
  },
}
